import { Button } from '@edsn/pie-components';
import CsvIcon from '@iconify/icons-material-symbols/csv';
import { format } from 'date-fns';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Icon } from '#pie/components/icon/Icon';
import { useDebounce } from '#pie/hooks/useDebounce';
import { useExportCprContacts } from '#pie/internal/api/pie-bff';
import {
  cprContactGroupDetailFiltersAtom,
  cprContactGroupDetailSortingAtom,
} from '#pie/stores/cprContactGroupDetail';
import { paginationAtom } from '#pie/stores/pagination';
import { searchAtom } from '#pie/stores/search';
import { downloadBlob } from '#pie/utils/downloadBlob';

export const CprContactGroupDetailExport = () => {
  const { t } = useTranslation();
  const contactGroupId = useParams()['contactGroupId']!;
  const pagination = useAtomValue(paginationAtom);
  const filter = useAtomValue(cprContactGroupDetailFiltersAtom);
  const sorting = useAtomValue(cprContactGroupDetailSortingAtom);
  const search = useAtomValue(searchAtom);
  const debouncedSearch = useDebounce(search, 500);
  const sortCol = sorting[0];

  const { mutate, isPending: isDownloadingCsv } = useExportCprContacts({
    mutation: {
      onSuccess: (data: Blob) => {
        downloadBlob(
          data,
          `Cpr_contactgroepen_detail_${format(new Date(), 'yyyy-MM-dd')}.csv`,
        );
      },
    },
  });

  return (
    <Button
      className="mr-4"
      iconStart={
        <Icon icon={CsvIcon} className="text-action-secondary-enabled" />
      }
      isLoading={isDownloadingCsv}
      action="tertiary"
      emphasis="subtle"
      onClick={() =>
        mutate({
          data: {
            filter: { ...filter, contactGroupIds: [contactGroupId] },
            pagination,
            search: debouncedSearch,
            sorting: sortCol && { descending: sortCol.desc, field: sortCol.id },
          },
        })
      }
    >
      {t('cpr_contact_group_detail.header.button.export')}
    </Button>
  );
};
